/** Demo Forms Per Brand * */
export const FORM_DEMO_LAWPAY = 2198;
export const FORM_DEMO_LAWPAY_CAL = 1547;
export const FORM_DEMO_LAWPAY_BANK = 2425;
export const FORM_DEMO_LAWPAY_BDR = 2428;
export const FORM_DEMO_CPACHARGE = 1644;
export const FORM_DEMO_CLIENTPAY = 2791;
export const FORM_DEMO_DESIGNPAY = 2295;
export const FORM_DEMO_AFFINIPAY = 1874;
export const FORM_DEMO_EVENTS = 2774;
export const FORM_DEMO_TESTING = 3030;
export const FORM_DEMO_LAWPAY_ENTERPRISE = 3226;

/** SignUp Forms */
export const FORM_SIGNUP_AFFINIPAY = 2070;
export const FORM_SIGNUP_ASSOCIATIONS = 2070;
export const FORM_SIGNUP_CLIENTPAY = 2736;
export const FORM_SIGNUP_CPACHARGE = 1646;
export const FORM_SIGNUP_DESIGNPAY = 2293;
export const FORM_SIGNUP_LAWPAY = 1541;
export const FORM_SIGNUP_MYCASE = 3227;

/* Contact Forms */
export const FORM_CONTACT_AFFINIPAY = 1875;
export const FORM_CONTACT_BIZ_DEV = 2276;
export const FORM_CONTACT_CLIENTPAY = 2688;
export const FORM_CONTACT_CPACHARGE = 1642;
export const FORM_CONTACT_CPACHARGE_DYNAMIC = 2213;
export const FORM_CONTACT_DESIGNPAY = 2230;
export const FORM_CONTACT_LAWPAY = 1143;
export const FORM_CONTACT_LAWPAY_ENTERPRISE = 2082;

/* Referral Forms */
export const FORM_REFERRAL_AFFINIPAY = 2049;
export const FORM_REFERRAL_CLIENTPAY = 2787;
export const FORM_REFERRAL_CPACHARGE = 1702;
export const FORM_REFERRAL_DESIGNPAY = 2330;
export const FORM_REFERRAL_LAWPAY = 1352;
export const FORM_REFERRAL_INTEGRATION = 2423;

/*  Partner Referral Forms */
export const FORM_CONTACT_CLIENTPAY_FINDLAW = 2271;
export const FORM_CONTACT_CLIENTPAY_FIRMCENTRAL = 2770;
export const FORM_CONTACT_CLIENTPAY_JURIS = 2769;
export const FORM_CONTACT_CLIENTPAY_PROLAW = 2768;

/* Partner Contact Forms */
export const FORM_CONTACT_CLIENTPAY_PARTNER = 2794;
export const FORM_CONTACT_CPACHARGE_PARTNER = 2262;
export const FORM_CONTACT_DESIGNPAY_PARTNER = 2324;
export const FORM_CONTACT_LAWPAY_PARTNER = 2025;

export const FORM_CONTACT_ARRAY = [   //  %w( 1994 2027        2794 2770 2771)
  FORM_CONTACT_AFFINIPAY,
  FORM_CONTACT_BIZ_DEV,
  FORM_CONTACT_CLIENTPAY,
  FORM_CONTACT_CPACHARGE,
  FORM_CONTACT_CPACHARGE_DYNAMIC,
  FORM_CONTACT_DESIGNPAY,
  FORM_CONTACT_LAWPAY,
  FORM_CONTACT_LAWPAY_ENTERPRISE,
  FORM_CONTACT_CLIENTPAY_FINDLAW,
  FORM_CONTACT_CLIENTPAY_JURIS,
  FORM_CONTACT_CLIENTPAY_FIRMCENTRAL,
  FORM_CONTACT_CLIENTPAY_JURIS,
  FORM_CONTACT_CLIENTPAY_PROLAW,
  FORM_CONTACT_CLIENTPAY_PARTNER,
  FORM_CONTACT_CPACHARGE_PARTNER,
  FORM_CONTACT_DESIGNPAY_PARTNER,
  FORM_CONTACT_LAWPAY_PARTNER,
];

export const FORM_DEMO_ARRAY = [  
  FORM_DEMO_AFFINIPAY,
  FORM_DEMO_CLIENTPAY,
  FORM_DEMO_CPACHARGE,
  FORM_DEMO_DESIGNPAY,
  FORM_DEMO_LAWPAY,
  FORM_DEMO_LAWPAY_CAL,
  FORM_DEMO_LAWPAY_BDR,
  FORM_DEMO_LAWPAY_BANK,
  FORM_DEMO_EVENTS,
  FORM_DEMO_TESTING,
  FORM_DEMO_LAWPAY_ENTERPRISE,
];

export const FORM_SIGNUP_ARRAY = [  // %w()
  FORM_SIGNUP_AFFINIPAY,
  FORM_SIGNUP_ASSOCIATIONS,
  FORM_SIGNUP_CLIENTPAY,
  FORM_SIGNUP_CPACHARGE,
  FORM_SIGNUP_LAWPAY, 
  FORM_SIGNUP_DESIGNPAY,
  FORM_SIGNUP_MYCASE
];

export const AFFINIPAY_FORM_ARRAY = [
  FORM_DEMO_AFFINIPAY,
  FORM_CONTACT_AFFINIPAY,
  FORM_SIGNUP_AFFINIPAY,
  FORM_SIGNUP_ASSOCIATIONS,
  FORM_REFERRAL_AFFINIPAY,
];

export const LAWPAY_FORM_ARRAY = [
  FORM_DEMO_LAWPAY,
  FORM_DEMO_LAWPAY_BANK,
  FORM_DEMO_LAWPAY_BDR,
  FORM_DEMO_LAWPAY_CAL,
  FORM_DEMO_LAWPAY_ENTERPRISE,
  FORM_SIGNUP_LAWPAY,
  FORM_CONTACT_LAWPAY,
  FORM_CONTACT_LAWPAY_ENTERPRISE,
  FORM_CONTACT_LAWPAY_PARTNER,
  FORM_REFERRAL_LAWPAY,
];

export const CPACHARGE_FORM_ARRAY = [
  FORM_DEMO_CPACHARGE,
  FORM_SIGNUP_CPACHARGE,
  FORM_REFERRAL_CPACHARGE,
  FORM_CONTACT_CPACHARGE,
  FORM_CONTACT_CPACHARGE_DYNAMIC,
  FORM_CONTACT_CPACHARGE_PARTNER,
];

export const CLIENTPAY_FORM_ARRAY = [
  FORM_CONTACT_CLIENTPAY,
  FORM_CONTACT_CLIENTPAY_FINDLAW,
  FORM_CONTACT_CLIENTPAY_JURIS,
  FORM_CONTACT_CLIENTPAY_PARTNER,
  FORM_CONTACT_CLIENTPAY_PROLAW,
  FORM_DEMO_CLIENTPAY,
  FORM_REFERRAL_CLIENTPAY,
  FORM_SIGNUP_CLIENTPAY,
];

export const MYCASE_FORM_ARRAY = [
  FORM_SIGNUP_MYCASE
];
